export default __webpack_public_path__ + "static/media/analysis.f0e09b72.jpg";